import { EErrorCode } from '../../../commons/entities/error-code';
import { LABELS } from '../../../commons/constants/labels.constant';

export interface ErrorParams {
  id: number;
  title: string;
  text: string;
  buttontext: string;
  contactLink: boolean;
  retryButton: boolean;
}

export const errors: Record<string, ErrorParams> = {
  [EErrorCode.Error_0_offline]: {
    id: 1,
    title: LABELS.generalErrorTitle,
    text: LABELS.offlineErrorText,
    buttontext: LABELS.generalErrorRetryButton,
    contactLink: false,
    retryButton: true,
  },
  [EErrorCode.Error_500_server_error]: {
    id: 2,
    title: LABELS.loginErrorTitle,
    text: LABELS.loginErrorText,
    buttontext: LABELS.loginErrorLink,
    contactLink: true,
    retryButton: true,
  },
  [EErrorCode.Error_403_server_error]: {
    id: 3,
    title: LABELS.generalErrorTitle,
    text: LABELS.errorText403,
    buttontext: LABELS.loginErrorLink,
    contactLink: true,
    retryButton: true,
  },
  [EErrorCode.Error_404_server_error]: {
    id: 4,
    title: LABELS.generalErrorTitle,
    text: LABELS.errorText403,
    buttontext: LABELS.loginErrorLink,
    contactLink: true,
    retryButton: true,
  },
  [EErrorCode.Error_TC_invalid_version]: {
    id: 5,
    title: LABELS.termsErrorTitle,
    text: LABELS.termsErrorText,
    buttontext: LABELS.termsErrorButton,
    contactLink: false,
    retryButton: true,
  },
  [EErrorCode.Error_Account_Is_Not_Reachable]: {
    id: 6,
    title: LABELS.generalErrorTitle,
    text: LABELS.accountIsNotReachable,
    buttontext: LABELS.loginErrorLink,
    contactLink: true,
    retryButton: true,
  },
};
